import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const PrivacyLayerPage = lazy(() => import('../pages/privacy-layer/page'));
const ProtocolPage = lazy(() => import('../pages/protocol/page'));
const IdentityLayerPage = lazy(() => import('../pages/identity-layer/page'));
const EconomyLayerPage = lazy(() => import('../pages/economy-layer/page'));
const InteropLayerPage = lazy(() => import('../pages/interop-layer/page'));
const TechnologyPage = lazy(() => import('../pages/technology/page'));
const EcosystemPage = lazy(() => import('../pages/ecosystem/page'));
const DevelopersPage = lazy(() => import('../pages/developers/page'));
const CommunityPage = lazy(() => import('../pages/community/page'));
const WhitepaperPage = lazy(() => import('../pages/whitepaper/page'));
const RoadmapPage = lazy(() => import('../pages/roadmap/page'));
const GovernancePage = lazy(() => import('../pages/governance/page'));
const DocsPage = lazy(() => import('../pages/docs/page'));
const SDKPage = lazy(() => import('../pages/sdk/page'));
const APIPage = lazy(() => import('../pages/api/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const JobApplicationPage = lazy(() => import('../pages/job-application/page'));
const PrivacyDeFiPage = lazy(() => import('../pages/privacy-defi/page'));
const DataMarketplacePage = lazy(() => import('../pages/data-marketplace/page'));
const IdentityVerificationPage = lazy(() => import('../pages/identity-verification/page'));
const SupplyChainPrivacyPage = lazy(() => import('../pages/supply-chain-privacy/page'));
const SupplyChainPrivacyDocsPage = lazy(() => import('../pages/supply-chain-privacy-docs/page'));
const DeveloperEcosystemPage = lazy(() => import('../pages/developer-ecosystem/page'));
const NetworkStatsPage = lazy(() => import('../pages/network-stats/page'));
const ZKPGuidePage = lazy(() => import('../pages/zkp-guide/page'));
const PrivacyProtectionGuidePage = lazy(() => import('../pages/privacy-protection-guide/page'));
const DataSovereigntyGuidePage = lazy(() => import('../pages/data-sovereignty-guide/page'));
const MoreLearningResourcesPage = lazy(() => import('../pages/more-learning-resources/page'));
const PrivacyVotingPage = lazy(() => import('../pages/privacy-voting/page'));
const ZKIdentityVerificationPage = lazy(() => import('../pages/zk-identity-verification/page'));
const EncryptedDataTransactionsPage = lazy(() => import('../pages/encrypted-data-transactions/page'));
const AboutTitronPage = lazy(() => import('../pages/about-titron/page'));
const WalletConnectPage = lazy(() => import('../pages/wallet-connect/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const CookieSettingsPage = lazy(() => import('../pages/cookie-settings/page'));
const SDKDocsPage = lazy(() => import('../pages/sdk-docs/page'));
const APIDocsPage = lazy(() => import('../pages/api-docs/page'));
const DataMarketplaceDocsPage = lazy(() => import('../pages/data-marketplace-docs/page'));
const IdentityVerificationDocsPage = lazy(() => import('../pages/identity-verification-docs/page'));

// 简化的路由配置，移除语言前缀
const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/privacy-layer', element: <PrivacyLayerPage /> },
  { path: '/identity-layer', element: <IdentityLayerPage /> },
  { path: '/economy-layer', element: <EconomyLayerPage /> },
  { path: '/interop-layer', element: <InteropLayerPage /> },
  { path: '/protocol', element: <ProtocolPage /> },
  { path: '/technology', element: <TechnologyPage /> },
  { path: '/ecosystem', element: <EcosystemPage /> },
  { path: '/developers', element: <DevelopersPage /> },
  { path: '/community', element: <CommunityPage /> },
  { path: '/whitepaper', element: <WhitepaperPage /> },
  { path: '/roadmap', element: <RoadmapPage /> },
  { path: '/governance', element: <GovernancePage /> },
  { path: '/docs', element: <DocsPage /> },
  { path: '/sdk', element: <SDKPage /> },
  { path: '/api', element: <APIPage /> },
  { path: '/company', element: <CompanyPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/careers', element: <CareersPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/job-application/:jobId', element: <JobApplicationPage /> },
  { path: '/privacy-defi', element: <PrivacyDeFiPage /> },
  { path: '/data-marketplace', element: <DataMarketplacePage /> },
  { path: '/identity-verification', element: <IdentityVerificationPage /> },
  { path: '/supply-chain-privacy', element: <SupplyChainPrivacyPage /> },
  { path: '/supply-chain-privacy-docs', element: <SupplyChainPrivacyDocsPage /> },
  { path: '/developer-ecosystem', element: <DeveloperEcosystemPage /> },
  { path: '/network-stats', element: <NetworkStatsPage /> },
  { path: '/zkp-guide', element: <ZKPGuidePage /> },
  { path: '/privacy-protection-guide', element: <PrivacyProtectionGuidePage /> },
  { path: '/data-sovereignty-guide', element: <DataSovereigntyGuidePage /> },
  { path: '/more-learning-resources', element: <MoreLearningResourcesPage /> },
  { path: '/privacy-voting', element: <PrivacyVotingPage /> },
  { path: '/zk-identity-verification', element: <ZKIdentityVerificationPage /> },
  { path: '/encrypted-data-transactions', element: <EncryptedDataTransactionsPage /> },
  { path: '/about-titron', element: <AboutTitronPage /> },
  { path: '/wallet-connect', element: <WalletConnectPage /> },
  { path: '/terms-of-service', element: <TermsOfServicePage /> },
  { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
  { path: '/cookie-settings', element: <CookieSettingsPage /> },
  { path: '/sdk-docs', element: <SDKDocsPage /> },
  { path: '/api-docs', element: <APIDocsPage /> },
  { path: '/data-marketplace-docs', element: <DataMarketplaceDocsPage /> },
  { path: '/identity-verification-docs', element: <IdentityVerificationDocsPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
